/**
 * @typedef {import('./lib/index.js').Options} Options
 * @typedef {import('./lib/index.js').Processor} Processor
 */

export {defaultHandlers, all, one} from 'mdast-util-to-hast'

export {default} from './lib/index.js'
